export class BasicHbFilter {
  page: number = 1;
  size: number = 30;
  name: string | null = null;
  alias?: string | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
  deleted: boolean = false;               
}
